var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadTemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 15H2.75C1.50736 15 0.5 13.9927 0.5 12.75V0.75C0.5 0.33579 0.83579 0 1.25 0H11.75C12.1642 0 12.5 0.33579 12.5 0.75V9.75H15.5V12.75C15.5 13.9927 14.4927 15 13.25 15ZM12.5 11.25V12.75C12.5 13.1642 12.8358 13.5 13.25 13.5C13.6642 13.5 14 13.1642 14 12.75V11.25H12.5ZM3.5 3.75V5.25H9.5V3.75H3.5ZM3.5 6.75V8.25H9.5V6.75H3.5ZM3.5 9.75V11.25H7.25V9.75H3.5Z",
    fill: "#2E3031"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadTemplate);
export default __webpack_public_path__ + "static/media/download-template.e5a2783346303583fc7bda80c03f3051.svg";
export { ForwardRef as ReactComponent };